import { DoqFaceSvgProps } from '../types';

const DropzoneError = ({ size, className }: DoqFaceSvgProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 320 320"
    fill="none"
    className={className}
    role="presentation"
  >
    <defs>
      <circle id="path-1" cx="160" cy="160" r="160"></circle>
    </defs>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="dropzone_error">
        <circle
          id="Oval"
          fill="#CC3D3D"
          fillRule="nonzero"
          cx="160"
          cy="160"
          r="160"
        ></circle>
        <g id="Clipped">
          <mask id="mask-2" fill="white">
            <use xlinkHref="#path-1"></use>
          </mask>
          <g id="Oval"></g>
          <g id="Group" mask="url(#mask-2)" fill="#FFFFFF" fillRule="nonzero">
            <g transform="translate(80.000000, 120.000000)" id="Path">
              <path d="M96.4908889,0 L103.694667,6.99133333 L110.896889,0 L136.374889,0 L160,22.9328889 L160,73.6628889 L159.788889,73.2555556 L148.164444,95.7451111 L159.671111,106.915556 L151.453333,114.893333 L159.977778,123.168889 L160,123.146667 L160,184 C160,192.835556 152.835556,200 144,200 L16.0006667,200 C7.16422222,200 0,192.835556 0,184 L0,157.651111 L8.43066667,149.468889 L1.95,143.175556 L6.42688889,138.831111 L0,132.588889 L0,79.734 L6.23888889,73.6784444 L0.416,68.026 L28.432,0 L96.4908889,0 Z"></path>
              <path d="M96.4908889,0 L103.694667,6.99133333 L110.896889,0 L136.374889,0 L160,22.9328889 L160,73.6628889 L159.788889,73.2555556 L148.164444,95.7451111 L159.671111,106.915556 L151.453333,114.893333 L159.977778,123.168889 L160,123.146667 L160,184 C160,192.835556 152.835556,200 144,200 L16.0006667,200 C7.16422222,200 0,192.835556 0,184 L0,157.651111 L8.43066667,149.468889 L1.95,143.175556 L6.42688889,138.831111 L0,132.588889 L0,79.734 L6.23888889,73.6784444 L0.416,68.026 L28.432,0 L96.4908889,0 Z"></path>
            </g>
          </g>
        </g>
        <path
          d="M149.999556,175.797111 C149.999556,180.215556 146.417778,183.797111 141.999556,183.797111 C137.581333,183.797111 133.999556,180.215556 133.999556,175.797111 C133.999556,171.378889 137.581333,167.797111 141.999556,167.797111 C146.417778,167.797111 149.999556,171.378889 149.999556,175.797111 Z"
          id="Path"
          fill="#2974C4"
          fillRule="nonzero"
        ></path>
        <path
          d="M179.616889,165.393333 C182.155333,162.854889 186.270889,162.854889 188.809333,165.393333 C191.347778,167.931778 191.347778,172.047333 188.809333,174.585778 L176.788444,186.606667 C174.25,189.145111 170.134444,189.145111 167.596,186.606667 C165.057778,184.068222 165.057778,179.952667 167.596,177.414222 L179.616889,165.393333 Z"
          id="Path"
          fill="#FF78A8"
          fillRule="nonzero"
          opacity="0.299691"
        ></path>
        <path
          d="M176.788444,165.393333 C174.25,162.854889 170.134444,162.854889 167.596,165.393333 C165.057778,167.931778 165.057778,172.047333 167.596,174.585778 L179.616889,186.606667 C182.155333,189.145111 186.270889,189.145111 188.809333,186.606667 C191.347778,184.068222 191.347778,179.952667 188.809333,177.414222 L176.788444,165.393333 Z"
          id="Path"
          fill="#E5A3BB"
          fillRule="nonzero"
          opacity="0.790471"
        ></path>
        <path
          d="M179.263778,172.110889 C178.482889,171.329778 177.216444,171.329778 176.435333,172.110889 L174.314,174.232222 C173.533111,175.013333 173.533111,176.279556 174.314,177.060667 L176.435333,179.182 C177.216444,179.963111 178.482889,179.963111 179.263778,179.182 L181.385111,177.060667 C182.166222,176.279556 182.166222,175.013333 181.385111,174.232222 L179.263778,172.110889 Z"
          id="Path"
          fill="#141414"
          fillRule="nonzero"
          opacity="0.317701"
        ></path>
        <path
          d="M195.121333,100.263333 L193.084444,98.5797778 C192.121556,97.7828889 191.600889,96.5142222 191.687333,95.1668889 L191.868667,92.3164444 L190.175111,94.6164444 C189.375556,95.7042222 188.160444,96.3431111 186.911333,96.3328889 L184.268667,96.3133333 L186.305778,97.9971111 C187.269111,98.7922222 187.789111,100.062667 187.702667,101.41 L187.521556,104.260222 L189.214889,101.960222 C190.014444,100.872667 191.229556,100.233556 192.478667,100.243778 L195.121333,100.263333 Z"
          id="Path"
          fill="#FFC356"
          fillRule="nonzero"
        ></path>
        <path
          d="M223.32,103.952 L223.728889,107.096889 L221.425333,104.916889 C220.337556,103.885556 218.748222,103.452 217.156222,103.752222 L213.788,104.384667 L216.279556,102.031556 C217.458222,100.92 218.041556,99.3793333 217.846667,97.8931111 L217.436889,94.7482222 L219.740222,96.9282222 C220.828,97.9595556 222.417778,98.3931111 224.008889,98.0931111 L227.377778,97.4604444 L224.886667,99.8135556 C223.706667,100.925111 223.126667,102.464667 223.32,103.952 Z"
          id="Path"
          fill="#FFC356"
          fillRule="nonzero"
        ></path>
        <path
          d="M244.18,125.295333 L242.808889,128.933556 L241.437778,125.295333 C240.791111,123.575111 239.217778,122.226222 237.208889,121.671778 L232.964444,120.496 L237.208889,119.320444 C239.217778,118.766 240.791111,117.417111 241.437778,115.696889 L242.808889,112.058667 L244.18,115.696889 C244.826667,117.417111 246.4,118.766 248.408889,119.320444 L252.653333,120.496 L248.408889,121.671778 C246.4,122.226222 244.831111,123.575111 244.18,125.295333 Z"
          id="Path"
          fill="#FFC356"
          fillRule="nonzero"
        ></path>
        <path
          d="M232.82,151.911333 L232.171111,148.000444 C231.864444,146.150889 232.524444,144.202222 233.946667,142.762222 L236.957778,139.713778 L232.777778,140.651111 C230.802222,141.095333 228.797778,140.623111 227.393333,139.382222 L224.42,136.759333 L225.068889,140.670222 C225.377778,142.518222 224.715556,144.468444 223.293333,145.908444 L220.282667,148.956889 L224.462222,148.019556 C226.437778,147.575111 228.442222,148.047556 229.846667,149.288444 L232.82,151.911333 Z"
          id="Path"
          fill="#FFC356"
          fillRule="nonzero"
        ></path>
        <path
          d="M194.036222,163.968222 L192.997556,157.710889 C192.508222,154.751778 193.562667,151.633778 195.840889,149.329778 L200.656889,144.452222 L193.968444,145.951778 C190.807333,146.662889 187.600444,145.907111 185.354,143.921778 L180.598,139.725333 L181.636667,145.982444 C182.13,148.939556 181.071333,152.059556 178.793333,154.363556 L173.977111,159.241111 L180.665778,157.741556 C183.826889,157.030444 187.033778,157.786222 189.28,159.771556 L194.036222,163.968222 Z"
          id="Path"
          fill="#FFC356"
          fillRule="nonzero"
        ></path>
        <path
          d="M135.808889,164.933556 L137.180444,161.295333 C137.830222,159.575111 139.401111,158.226222 141.408,157.671778 L145.652667,156.496 L141.408,155.320444 C139.401111,154.766 137.827333,153.417111 137.180444,151.696889 L135.808889,148.058667 L134.437333,151.696889 C133.790444,153.417111 132.216667,154.766 130.21,155.320444 L125.965111,156.496 L130.21,157.671778 C132.216667,158.226222 133.790444,159.575111 134.437333,161.295333 L135.808889,164.933556 Z"
          id="Path"
          fill="#FFC356"
          fillRule="nonzero"
        ></path>
        <path
          d="M154.953556,102.044444 L156.990444,103.728222 L154.347778,103.708667 C153.098667,103.698444 151.883556,104.337333 151.084,105.425111 L149.390667,107.725111 L149.571778,104.874667 C149.658222,103.527556 149.138222,102.256889 148.174889,101.462 L146.137778,99.7782222 L148.780444,99.7977778 C150.029556,99.808 151.244667,99.1691111 152.044444,98.0813333 L153.737778,95.7813333 L153.556667,98.6317778 C153.47,99.9788889 153.990667,101.247778 154.953556,102.044444 Z"
          id="Path"
          fill="#FFC356"
          fillRule="nonzero"
        ></path>
        <path
          d="M112.982444,104.126889 L111.556667,102.948222 C110.882667,102.390444 110.518222,101.502222 110.578667,100.559111 L110.705556,98.564 L109.520222,100.174 C108.960444,100.935333 108.11,101.382667 107.235556,101.375333 L105.385556,101.361778 L106.811556,102.540444 C107.486,103.096889 107.85,103.986222 107.789333,104.929333 L107.662667,106.924444 L108.848,105.314667 C109.407778,104.553111 110.258222,104.106 111.132667,104.113111 L112.982444,104.126889 Z"
          id="Path"
          fill="#FFC356"
          fillRule="nonzero"
        ></path>
        <path
          d="M75.9977778,121.885778 L74.898,125.089111 L73.7982222,121.885778 C73.2797778,120.371333 72.0177778,119.183778 70.4086667,118.695556 L67.0051111,117.660444 L70.4086667,116.625333 C72.0177778,116.137333 73.2797778,114.949778 73.7982222,113.435333 L74.898,110.232 L75.9977778,113.435333 C76.5164444,114.949778 77.7782222,116.137333 79.3873333,116.625333 L82.7908889,117.660444 L79.3873333,118.695556 C77.7782222,119.183778 76.5186667,120.371333 75.9977778,121.885778 Z"
          id="Path"
          fill="#FFC356"
          fillRule="nonzero"
        ></path>
        <path
          d="M96.8962222,160.062889 L98.8288889,154.494667 C99.7442222,151.862 101.957556,149.797556 104.785111,148.949111 L110.765778,147.149778 L104.785111,145.350667 C101.957556,144.502 99.7402222,142.437778 98.8288889,139.805111 L96.8962222,134.236889 L94.9637778,139.805111 C94.0524444,142.437778 91.8351111,144.502 89.0073333,145.350667 L83.0266667,147.149778 L89.0073333,148.949111 C91.8351111,149.797556 94.0524444,151.862 94.9637778,154.494667 L96.8962222,160.062889 Z"
          id="Path"
          fill="#FFC356"
          fillRule="nonzero"
        ></path>
        <g
          id="Group"
          opacity="0.5"
          transform="translate(95.555556, 240.000000)"
          fill="#2974C4"
          fillRule="nonzero"
        >
          <path
            d="M0.443777778,3 C0.443777778,2.44666667 0.891555556,2 1.44377778,2 L127.444444,2 C127.995556,2 128.444444,2.44666667 128.444444,3 L128.444444,5 C128.444444,5.55333333 127.995556,6 127.444444,6 L1.44377778,6 C0.891555556,6 0.443777778,5.55333333 0.443777778,5 L0.443777778,3 Z"
            id="Path"
          ></path>
          <path
            d="M0.443777778,37 C0.443777778,36.4466667 0.891555556,36 1.44377778,36 L127.444444,36 C127.995556,36 128.444444,36.4466667 128.444444,37 L128.444444,39 C128.444444,39.5533333 127.995556,40 127.444444,40 L1.44377778,40 C0.891555556,40 0.443777778,39.5533333 0.443777778,39 L0.443777778,37 Z"
            id="Path"
          ></path>
          <path
            d="M1.44377778,18 C0.891555556,18 0.443777778,18.4466667 0.443777778,19 L0.443777778,21 C0.443777778,21.5533333 0.891555556,22 1.44377778,22 L127.444444,22 C127.995556,22 128.444444,21.5533333 128.444444,21 L128.444444,19 C128.444444,18.4466667 127.995556,18 127.444444,18 L1.44377778,18 Z"
            id="Path"
          ></path>
          <path
            d="M0.443777778,53 C0.443777778,52.4466667 0.891555556,52 1.44377778,52 L127.444444,52 C127.995556,52 128.444444,52.4466667 128.444444,53 L128.444444,55 C128.444444,55.5533333 127.995556,56 127.444444,56 L1.44377778,56 C0.891555556,56 0.443777778,55.5533333 0.443777778,55 L0.443777778,53 Z"
            id="Path"
          ></path>
        </g>
        <path
          d="M161.850667,200.005333 C160.815778,200.081556 160,200.945333 160,201.999778 C160,203.104444 160.895333,203.999778 162,203.999778 L176.5,203.999778 C178.432889,203.999778 180,205.566889 180,207.499778 C180,207.669778 179.987778,207.837111 179.964444,208.000667 L180,208.000889 C180.000444,209.104889 180.895778,209.999778 182,209.999778 C183.104667,209.999778 184,209.104444 184,207.999778 C184,207.941333 183.997556,207.883333 183.992667,207.826222 L183.983556,208.000444 C183.994444,207.834889 184,207.668 184,207.499778 C184,203.357556 180.642222,199.999778 176.5,199.999778 L162,199.999778 L161.850667,200.005333 Z"
          id="Path"
          fill="#2974C4"
        ></path>
      </g>
    </g>
  </svg>
);

export { DropzoneError };
